function GreenCheckIcon({ transparent = false }: { transparent?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="min-w-8"
		>
			<rect width="24" height="24" rx="12" fill="#2EDBCA" />
			<path
				d="M6 11.7692L9.80766 15.5768L18 8"
				stroke={transparent ? "hsla(214, 100%, 29%, 1)" : "white"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default GreenCheckIcon;
